/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useState } from "react"
import {
    TitleSection,
    ModalTitle,
    ContentSection,
    FooterSection,
    Column,
    Label,
    Row,
    Input,
    Button,
    Icon,
    Color,
    isSmallMobileScreen,
} from "trux"
import { validateEmail } from "../../../util/validator"
import { checkForEmail } from "../actions"
export const CollectPlayerEmail = (props) => {
    const [email, setEmail] = useState("")
    const [error, setError] = useState(null)

    const onContinue = async () => {
        let emailCheck = await checkForEmail(email)
        console.log("email check", emailCheck)
        if (email.length === 0) {
            setError(
                // eslint-disable-next-line quotes
                "You must enter a player email to continue. If the player does not have their own email then you can go back a step, select “No”, and continue."
            )
        } else if (!validateEmail(email)) {
            setError("Invalid email address")
        } else if (emailCheck) {
            setError("This email already exists.")
        } else {
            props.updatePlayerEmail(email)
            props.onDone()
        }
    }
    return (
        <>
            <TitleSection onBackClick={props.onBackClick}>
                <ModalTitle content="Player email" />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Input
                        type={Input.Type.Email}
                        label={
                            <Row>
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="Email"
                                    marginRight="1"
                                />{" "}
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="*"
                                    color={Color.Error}
                                />
                            </Row>
                        }
                        onChange={(e) => setEmail(e)}
                        value={email}
                        width="343px"
                        error={error}
                        marginBottom="7"
                    />
                    {!isSmallMobileScreen() && (
                        <Button
                            type={Label.Type.Heading5}
                            onClick={onContinue}
                            span="12"
                            className="button"
                            content={
                                <Row>
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Continue"
                                        marginRight="2"
                                    />{" "}
                                    <Icon
                                        size={16}
                                        type={Icon.Type.CheveronRight}
                                    />
                                </Row>
                            }
                        />
                    )}
                </Column>
            </ContentSection>

            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        type={Label.Type.Heading5}
                        onClick={onContinue}
                        span="12"
                        className="button"
                        content={
                            <Row>
                                <Label
                                    type={Label.Type.InnerButton}
                                    content="Continue"
                                    marginRight="2"
                                />{" "}
                                <Icon
                                    size={16}
                                    type={Icon.Type.CheveronRight}
                                />
                            </Row>
                        }
                    />
                </FooterSection>
            )}
        </>
    )
}
